// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_eGW","cls2":"ImpactStatTile-cls2_hi0 ImpactStatTile-cls1_eGW","statStyle-delta_chip":"ImpactStatTile-statStyle-delta_chip_Wpg"};